import Vue from 'vue'
import bugsnag from '@bugsnag/js'
import bugsnagVue from '@bugsnag/plugin-vue'

const bugsnagClient = bugsnag({
    apiKey: '08147762a6cb22540611e5260759b821',
    notifyReleaseStages: [ 'production', 'staging' ],
    releaseStage: process.env.NODE_ENV,
    beforeSend: (report) => {
        // Check for axios error responses with 403 status
        if (report.originalError && report.originalError.response && report.originalError.response.status === 403) {
            report.ignore();
        }
        
        // Check for generic 403 errors
        if (report.originalError && report.originalError.status === 403) {
            report.ignore();
        }
        
        // Check error message for 403 references
        const errorMessage = report.originalError && report.originalError.message;
        if (errorMessage && (
            errorMessage.includes('403') || 
            errorMessage.toLowerCase().includes('forbidden')
        )) {
            report.ignore();
        }
    }
}).use(bugsnagVue, Vue)

export default bugsnagClient
